import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export default function HealthCustomerdisplay() {
  const custDetail = useSelector((state) => state?.common?.customerDetail);
  // console.log("custDetail", custDetail);
  return (
    <>
      <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1 customer-card">
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">DATE OF BIRTH</div>
          <div className="indivtext">{custDetail?.DateOfBirth}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">GENDER</div>
          <div className="indivtext">{custDetail?.gender}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">CKYC NUMBER</div>
          <div className="indivtext">{custDetail?.ckyc_number}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">PAN NUMBER</div>
          <div className="indivtext">{custDetail?.PAN_Number}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">AADHAAR NUMBER</div>
          <div className="indivtext">{custDetail?.aadhaar_number}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">GSTIN</div>
          <div className="indivtext">{custDetail?.gst_number}</div>
        </div>
      </div>
    </>
  );
}
